//
// Module for the Benefit Claims - Benefit Claim Payment Detail partial view
//
rs.module("participant/benefit/claims/benefitclaimpaymentdetail",

    ["controls/components/event-banner"],

    function (eventBanner) {

        var _executeSelectionChanged;

        function initialize(jsSelectors, recipientGrid, columnIds, backendUrls, constants) {

            // initialize js selectors
            var inProgressContainer = $.js(jsSelectors.inProgressContainer);

            if (recipientGrid) {

                recipientGrid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeSelectionChanged && values.length > 0) {

                        eventBanner.removeAllMessages();

                        $.get(
                            backendUrls.getInProgress,
                            {
                                benefitClaimPaymentKey: rows[0][columnIds.benefitClaimPaymentKey],
                                partyStatus: constants.partyStatus,
                                claimType: constants.claimType,
                                separationType: constants.separationType,
                                separationSubType: constants.separationSubType
                            },
                            function (data) {
                                inProgressContainer.html(data);

                                // reset the client-side validations on the in progress form
                                var inProgressForm = inProgressContainer.find("form");

                                if (inProgressForm.length > 0) {
                                    $.validator.resetValidation(inProgressForm);
                                }
                            }
                        );
                    }

                    _executeSelectionChanged = true;
                });

            }

            // Show the benefit popup when a popup link is clicked
            // These links take the place of the links to redirect to the benefit summary screen when the benefit has been cancelled and the payee is no longer a recipient
            $.js(jsSelectors.benefitPopupLink, { required: false, multiple: true }).click(function () {

                $.get(
                    backendUrls.getBenefitPopup,
                    {
                        benefitClaimPaymentKey: $(this).data("benefitclaimpaymentkey")
                    }

                ).done(function (results) {
                    var benefitModal = $.js(jsSelectors.cancelledBenefitModal);

                    benefitModal.js(jsSelectors.modalBody).html(results);
                    benefitModal.modal("show");
                });

            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);